"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawableToIntermediates = void 0;
const dist_1 = require("@faceyourmanga/fym-lib/dist");
const PublicDrawerController_1 = require("../drawer/PublicDrawerController");
function drawableToIntermediates(resources, drawableRequest) {
    const drawableRequestSet = drawableRequest.set;
    let drawableResources = drawableRequest.resources;
    /// Risolvo i link degli elementi
    const pDCtrl = new PublicDrawerController_1.PublicDrawerController(resources, drawableRequest.set);
    pDCtrl.import(drawableRequest, resources, drawableRequest.set);
    for (let i = 0, len = drawableResources.length; i < len; i++) {
        const drawable = drawableResources[i];
        const element = resources.element[drawable.elementId];
        if (element.requiredOtherElementsIds && element.requiredOtherElementsIds.length > 0) {
            element.requiredOtherElementsIds.forEach(linkId => {
                pDCtrl.addElement(resources, resources.element[linkId]);
                // non valido la transform dell'elemento, forzo la transform di chi lo linka
                const pDCtrlRawData = pDCtrl.getRawData();
                if (pDCtrlRawData) {
                    // lasciare == al posto di === perche' uno e' un objectid
                    const newLink = pDCtrlRawData.resources.filter(dr => dr.elementId == linkId);
                    if (newLink.length > 0) {
                        newLink[0].transform = drawable.transform;
                    }
                }
            });
        }
    }
    drawableResources = pDCtrl.export(resources, drawableRequest.set).resources;
    ///
    const categoryMaskMap = {};
    const transformCategoryMap = {};
    const result = [];
    // Calculate category e transform map
    for (let i = 0, len = drawableResources.length; i < len; i++) {
        const drawable = drawableResources[i];
        const element = resources.element[drawable.elementId];
        updateCategoryMaskMap(categoryMaskMap, drawable, element);
        updateTransformCategoryMap(transformCategoryMap, drawable, element);
    }
    // Conversion
    for (let i = 0, len = drawableResources.length; i < len; i++) {
        const drawable = drawableResources[i];
        const element = resources.element[drawable.elementId];
        const categoryIdForSet = dist_1.findCategoryOfElementForSet(resources, drawable.elementId, drawableRequestSet);
        let elementRequireThis = isALink(drawable.elementId, drawableResources, resources);
        result[i] = {
            elementId: drawable.elementId,
            categoryIdForSet: categoryIdForSet,
            svg: element.svg,
            bounding: elementRequireThis ? elementRequireThis.svgBounding : element.svgBounding,
            colors: drawable.colors,
            transforms: [drawable.transform ? drawable.transform : dist_1.ApplyTransform.default()],
            zIndex: element.zIndex || resources.category[categoryIdForSet].zIndex,
        };
        applyRecoursiveTransform(resources, drawableResources, transformCategoryMap, result[i], drawable.elementId, drawableRequestSet);
        // add masks to apply
        if (result[i].categoryIdForSet in categoryMaskMap) {
            result[i].masks = categoryMaskMap[result[i].categoryIdForSet];
        }
    }
    // Sorting
    return result.sort((a, b) => {
        return a.zIndex > b.zIndex ? 1 : -1;
    });
}
exports.drawableToIntermediates = drawableToIntermediates;
//// START TRANFORM ////////////////////////////////
function applyRecoursiveTransform(resources, drawableResources, transformCategoryMap, currentIntermediate, // link parent?
elementIdToGetTransform, set) {
    var _a;
    let elementRequireThis = isALink(elementIdToGetTransform, drawableResources, resources);
    if (!elementRequireThis) {
        // NO LINK
        // Aggiunge le trasformazioni di dipendenza se non è un link
        (_a = resources.category[currentIntermediate.categoryIdForSet].dependsOn) === null || _a === void 0 ? void 0 : _a.forEach((dependsCategoryId) => {
            if (dependsCategoryId in transformCategoryMap) {
                // currentIntermediate.transforms.push(transformCategoryMap[dependsCategoryId])
                recoursiveAddTransform(resources, drawableResources, dependsCategoryId, transformCategoryMap, currentIntermediate, set);
            }
        });
    }
    else {
        // LINK
        const categoryWithDeps = resources.category[dist_1.findCategoryOfElementForSet(resources, elementRequireThis.id, set)].dependsOn;
        if (categoryWithDeps) {
            for (let i = 0; i < categoryWithDeps.length; i++) {
                const dependsCategoryId = categoryWithDeps[i];
                if (dependsCategoryId in transformCategoryMap) {
                    // currentIntermediate.transforms.push(transformCategoryMap[dependsCategoryId])
                    recoursiveAddTransform(resources, drawableResources, dependsCategoryId, transformCategoryMap, currentIntermediate, set);
                }
            }
        }
    }
}
function recoursiveAddTransform(resources, drawableResources, dependsCategoryId, transformCategoryMap, currentIntermediate, // link parent?
set) {
    currentIntermediate.transforms.push(transformCategoryMap[dependsCategoryId]);
    const elementForCategory = drawableResources.find(d => resources.element[d.elementId].categories.includes(dependsCategoryId));
    if (elementForCategory) {
        const categoryWithDeps = resources.category[dist_1.findCategoryOfElementForSet(resources, elementForCategory.elementId, set)].dependsOn;
        if (categoryWithDeps) {
            for (let i = 0; i < categoryWithDeps.length; i++) {
                const dependsCategoryId = categoryWithDeps[i];
                if (dependsCategoryId in transformCategoryMap) {
                    recoursiveAddTransform(resources, drawableResources, dependsCategoryId, transformCategoryMap, currentIntermediate, set);
                }
            }
        }
    }
}
//// END TRANFORM ////////////////////////////////
function isALink(elementId, drawableResources, resources) {
    for (let i = 0; i < drawableResources.length; i++) {
        const element = resources.element[drawableResources[i].elementId];
        if (element.requiredOtherElementsIds &&
            element.requiredOtherElementsIds.map(id => id.toString()).includes(elementId.toString())) {
            return element;
        }
    }
    return false;
}
function updateCategoryMaskMap(categoryMaskMap, drawable, element) {
    element.masks &&
        element.masks.forEach((mask) => {
            mask.masking.forEach((categoryId) => {
                if (categoryId in categoryMaskMap === false) {
                    categoryMaskMap[categoryId] = [];
                }
                categoryMaskMap[categoryId].push({
                    path: mask.path,
                    transform: drawable.transform,
                    bounding: element.svgBounding,
                });
            });
        });
}
function updateTransformCategoryMap(transformCategoryMap, drawable, element) {
    if (drawable.transform) {
        element.categories.forEach((categoryId) => {
            if (drawable.transform) {
                transformCategoryMap[categoryId] = drawable.transform;
            }
        });
    }
}
